import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
// import coralTelecom from "../../assets/images/CoralTelecom.png";

function ContextMenu({ id, contextMenu, handleClose, name }) {

  const coralTelecom = "/images/CoralTelecom.png";

  const handleExportClick = () => {
    const input = document.getElementById(id);

    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF();

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();

      // Set the logo image
      const logoWidth = 40;
      const logoHeight = 25;
      const logoX = pdfWidth - logoWidth - 14;
      const logoY = 10;
      pdf.addImage(coralTelecom, "PNG", logoX, logoY, logoWidth, logoHeight);

      // Set the heading
      const heading = name;
      const headingFontSize = 18;
      const headingX = 14;
      const headingY = 15;
      pdf.setFontSize(headingFontSize);
      pdf.text(heading, headingX, headingY, { align: "left" });

      // Set the timestamp
      const timestamp = new Date().toLocaleString("en-IN"); // Get current timestamp
      const timestampFontSize = 12;
      const timestampX = 14;
      const timestampY = headingY + headingFontSize;
      pdf.setFontSize(timestampFontSize);
      pdf.text(timestamp, timestampX, timestampY, { align: "left" });

      const aspectRatio = canvas.width / canvas.height;

      let imgWidth, imgHeight;
      if (pdfWidth > pdfHeight) {
        imgWidth = pdfHeight * aspectRatio;
        imgHeight = pdfHeight;
      } else {
        imgWidth = pdfWidth;
        imgHeight = pdfWidth / aspectRatio;
      }

      const xPos = (pdfWidth - imgWidth) / 2;
      const yPos = (pdfHeight - imgHeight) / 2;

      pdf.addImage(imgData, "PNG", xPos, yPos, imgWidth, imgHeight, "", "FAST");
      pdf.save(`${name}.pdf`);
    });

    handleClose();
  };

  return (
    <Menu
      open={contextMenu !== null}
      onClose={handleClose}
      anchorReference="anchorPosition"
      anchorPosition={
        contextMenu !== null
          ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
          : undefined
      }
    >
      <MenuItem onClick={handleExportClick}>Export to PDF</MenuItem>
    </Menu>
  );
}

export default ContextMenu;
